import { render } from "./Header.vue?vue&type=template&id=04c05e22&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=04c05e22&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c05e22"]])

export default __exports__